import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TSyoteiZikanListGetReq,
  TSyoteiZikanListGetRes,
  TSyoteiZikanPutReq,
} from "./TSyoteiZikan"

/**
 * 所定時間に対するAPIリクエスト用サービス
 *
 * @export
 * @class SyoteiZikanService
 * @extends {ConnectApi}
 */
export default class SyoteiZikanService extends ConnectApi {
  /**
   * 休日 一覧取得
   *
   * @param {TSyoteiZikanListGetReq} params
   * @memberof syoteiZikanService
   */
  getList = async (params: TSyoteiZikanListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyoteiZikanListGetRes[]>> =
        await this.getInner(`/master/syoteizikan`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 休日 更新/削除
   *
   * @param {TKyuzituListPutReq} data
   * @memberof syoteiZikanService
   */
  put = async (data: TSyoteiZikanPutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `master/syoteizikan`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
